import { Reducer } from 'react';
import { CLEAR_PRIO_CACHE } from '../../../actions';
import { SET_ACTIVE_PROJECT, ActiveProjectAction } from '../actions';

const reducer: Reducer<string, ActiveProjectAction> = (
  state = null,
  action
) => {
  switch (action.type) {
    case SET_ACTIVE_PROJECT: {
      return action.projectId;
    }
    case CLEAR_PRIO_CACHE: {
      return null;
    }
    default:
      return state;
  }
};

export const getActiveProject = (state: string) => state;

export default reducer;
